import store from '../config/configureStore';
import settings from '../config/settings';

export const getService = (serviceName = 'archive-browser') => {
  let service;
  try {
    const state = store.store.getState();
    const client = state.websocket.websocket;
    service = client.service(serviceName);
    service.timeout = '500000';
  } catch (err) {
    throw new Error('Error, service not ready.');
  }

  return service;
};
